import FunctionCell_Download from "../../dataGrid/functionCells/download/FunctionCell_Download";

export function getReportParams(props) {
    return {
        collection: 'INVOICES',
        columns: [{
            field: 'ID',
            width: 80,
            pinned: 'left',
            hideFloatingFilter: true,
            cellRenderer: FunctionCell_Download,
            cellRendererParams: {
                cellFunctions: props.cellFunctions,
            }
        },
        {
            field: 'InvoiceNum',
            pinned: 'left',
        },
        {
            field: 'INV_Type_ID',
            type: 'text',
            width: 240,
        },
        {
            field: 'InvoiceNum',
        },
        {
            field: 'Ref_InvoiceNum',
        },
        {
            field: 'PartnerName',
            width: 350,
        },
        {
            field: 'Gross',
            type: 'float',
        },
        {
            field: 'Currency',
        },
        {
            field: 'InvDate',
            type: 'date',
        },
        {
            field: 'DeliveryDate',
            type: 'date',
        },
        {
            field: 'DueDate',
            type: 'date',
        },
        {
            field: 'OverdueDays',
            type: 'int',
        },
        {
            field: 'PaymentStatus',
            options: [
                { value: "", text: "###-pleaseSelect" },
                { value: "1", text: "###-paymentStatus-not-paid", },
                { value: "3", text: "###-paymentStatus-paid", },
            ]
        },
        {
            field: 'PreparedBy',
        },
        ],
        sort: 'InvoiceNum',
        limit: 5000,
        rowCountPerPage: 50,
        selectedFilters: [
            'PartnerName',
            'InvDate',
            'DeliveryDate',
            'DueDate',
            'PaymentStatus',
        ],
        selectedColumns: [
            'ID',
            'PartnerName',
            'InvoiceNum',
            'Ref_InvoiceNum',
            'Gross',
            'Currency',
            'InvDate',
            'DeliveryDate',
            'DueDate',
            'OverdueDays',
            'PaymentStatus',
            'PreparedBy',],
    };
}
